module.exports = __webpack_public_path__ + "img/go-top.b79f57a6.png";